import { DetailItemComponent } from '@aipb/gulliver/catalog/feature-detail-item';
import { DetailItem } from '@aipb/gulliver/catalog/model';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'cat-compare-desktop',
  templateUrl: './compare-desktop.component.html',
  styleUrls: ['./compare-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatCardModule, DetailItemComponent]
})
export class CompareDesktopComponent {
  @Input() first: DetailItem;
  @Input() second: DetailItem;
}
